__turbopack_context__.v({
  "secondary": "supertitle-module-scss-module__v63LnW__secondary",
  "superTitle": "supertitle-module-scss-module__v63LnW__superTitle",
});
